import React from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactDOM from "react-dom";


import { GetNoticiasEnAPI, GetCategoriaNoticiaEnAPI, ObtenerEndPoint } from "../../action/actionCreatorsRequests";



import {
    obtenerFechaLocalObjeto, construirFecha, convertirAMesACodigo, convertirCodigoAMeses, CodigoAMeses,
    MSGOK, obtenerToken, obtenerUsuario, traducirPagina, MSGERROR, recortarCadena

} from "../../librerias/funciones"

import VisorGenerico from "../VisorGenerico";

import { Button, Modal, Select, Row, Col, Pagination, Result } from 'antd';
import {
    MenuOutlined,
    HeartOutlined,
    ShareAltOutlined,
    SearchOutlined,
    CloseOutlined,
    UpOutlined,
    DownOutlined

} from '@ant-design/icons';


import { Layout } from 'antd';
import FichaDetalleNoticia from "./FichaDetalleNoticia";
import { CPDia_Mes_Anyo } from "../CPDiaMesAnyo"
const { Content } = Layout;
const { Option } = Select;

const Noticias = ({ activeItemReferencia, configApp, props, usuario }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)
    const [filtroLocal, setFiltroLocal] = React.useState({

        ID_CATEGORIA: null,
        ID_ESTADO: null,
        ID_TIPO_NOTICIA: null,
        CATEGORIAS: [],
        ESTADOS: [],
        TIPOS_NOTICIA: [],
        PALABRA: "",
        ORDERCOLUM: 1,
        ORDERDIR: "D",
        ID: null,
        ACTIVE_MENU: 0,
        INICIAL_MES: [
            { ID: 1, DESCRIPCION: "Enero", SELECCIONADO: true },
            { ID: 2, DESCRIPCION: "Febrero", SELECCIONADO: false },
            { ID: 3, DESCRIPCION: "Marzo", SELECCIONADO: false },
            { ID: 4, DESCRIPCION: "Abril", SELECCIONADO: false },
            { ID: 5, DESCRIPCION: "Mayo", SELECCIONADO: false },
            { ID: 6, DESCRIPCION: "Junio", SELECCIONADO: false },
            { ID: 7, DESCRIPCION: "Julio", SELECCIONADO: false },
            { ID: 8, DESCRIPCION: "Agosto", SELECCIONADO: false },
            { ID: 9, DESCRIPCION: "Septiembre", SELECCIONADO: false },
            { ID: 10, DESCRIPCION: "Octubre", SELECCIONADO: false },
            { ID: 11, DESCRIPCION: "Noviembre", SELECCIONADO: false },
            { ID: 12, DESCRIPCION: "Diciembre", SELECCIONADO: false },
        ],
        ANYOS: [],




    });


    const [modalBajaVisible, setModalBajaVisible] = React.useState({
        ABRIR_MODAL: false,
        ID: 0,
        ID_PADRE: 0,
        NOMBRE: "",
        ES_DOCUMENTO: false
    });



    const [abrirVisor, setAbrirVisor] = React.useState(false);
    const [hayLicencias, seHayLicencias] = React.useState(false);
    const [ficheroSeleccionado, setFicheroSeleccionado] = React.useState({});
    const [noticias, setNoticias] = React.useState([]);
    const [abrirDetalleNoticia, setAbrirDetalleNoticia] = React.useState(false);
    const [noticiaSeleccionada, setNoticiaSeleccionada] = React.useState({});



    const [filtroFecha, setFiltroFecha] = React.useState({
        CAMBIO_DIA: false,
        CAMBIO_MES: false,
        CAMBIO_ANIO: true,

        CAMBIO_CALENDARIO: false,
        ACCION_DESDE: 4,
        ACCION_HASTA: 5,
        FECHA_PARTIDA: "",

        DIA_SELECCIONADO: "",
        MES_SELECCIONADO: "",
        ANYO_SELECCIONADO: "",
        ID_DEPARTAMENTO: "",
        CODIGO_MES: 0


    });

    const [datosPaginacion, setDatosPaginacion] = React.useState({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 });

    /*
        const GetImagenNoticia = async (ORDERCOLUM, ORDERDIR, ID) => {
            let IMAGEN = "./imagenes/sinimagen.jpg"
            let registros = await GetNoticiasEnAPI(ORDERCOLUM, ORDERDIR, ID)
            if (registros !== undefined && registros !== null && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                const { IMAGEN_CONTENT_TYPE, IMAGEN_BYTES } = registros.REGISTROS[0]
                if (IMAGEN_BYTES !== null && IMAGEN_BYTES !== "") {
                    IMAGEN = `data:${IMAGEN_CONTENT_TYPE};base64,${IMAGEN_BYTES}`
                }
            }
    
            return IMAGEN;
        }
    
    */
    const crearAnyos = (ANYO_MAXIMO, NUM_ANYOS) => {
        let ANYOS = [{ ID: ANYO_MAXIMO, DESCRIPCION: ANYO_MAXIMO, SELECCIONADO: true }];
        let NUMERO = NUM_ANYOS;
        let ULTIMO_ANYO = ANYO_MAXIMO;
        if (NUMERO !== undefined && NUMERO !== null) {
            while (NUMERO > 0) {
                ULTIMO_ANYO = ULTIMO_ANYO - 1
                NUMERO = NUMERO - 1
                ANYOS.push({ ID: ULTIMO_ANYO, DESCRIPCION: ULTIMO_ANYO, SELECCIONADO: false })
            }
        }



        return ANYOS;
    }




    const buscarTipoNoticia = (registros) => {
        let TIPO_NOTICIAS = []
        TIPO_NOTICIAS.push({ ID: 0, DESCRIPCION: traducirPagina("Todas"), SELECCIONADO: true })

        registros.REGISTROS.map((registro) => {
            if (TIPO_NOTICIAS.length === 0) {
                TIPO_NOTICIAS.push({ ID: registro.ID_NOTICIA_TIPO, DESCRIPCION: registro.TIPO_NOTICIA, SELECCIONADO: true })
            } else {

                let EXISTE = TIPO_NOTICIAS.find((item) => item.ID === registro.ID_NOTICIA_TIPO)
                if (EXISTE === undefined) {
                    TIPO_NOTICIAS.push({ ID: registro.ID_NOTICIA_TIPO, DESCRIPCION: registro.TIPO_NOTICIA, SELECCIONADO: false })
                }
            }
        })
        return TIPO_NOTICIAS
    }


    const GetNoticias = (ORDERCOLUM, ORDERDIR, ID, FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, KEYWORDS) => {
        setNoticias([])
        setDatosPaginacion({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 })

        GetNoticiasEnAPI(ORDERCOLUM, ORDERDIR, ID, FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, KEYWORDS).then((registros) => {
            if (registros !== undefined && registros !== null && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                registros.IMAGEN_NOTICIA = "";



                //filtroLocal.ESTADOS = buscarEstadoNoticia(registros)
                filtroLocal.TIPOS_NOTICIA = buscarTipoNoticia(registros)

                setFiltroLocal({ ...filtroLocal })



                setNoticias(registros.REGISTROS)
            } else {
                setNoticias(registros.REGISTROS)

            }
        })
    }






    const fechaInicial = () => {
        let fechaLocal = obtenerFechaLocalObjeto(false);
        const FECHA_INICIAL = construirFecha(fechaLocal.MES, fechaLocal.ANIO.toString(), { DESDE: 2, HASTA: 3 })
        filtroFecha.CAMBIO_DIA = false;
        filtroFecha.CAMBIO_MES = false;
        filtroFecha.CAMBIO_ANIO = true;

        filtroFecha.ACCION_DESDE = 2;
        filtroFecha.ACCION_HASTA = 3;
        filtroFecha.FECHA_PARTIDA = FECHA_INICIAL
        filtroFecha.ANYO_SELECCIONADO = fechaLocal.ANIO
        filtroFecha.MES_SELECCIONADO = traducirPagina(convertirCodigoAMeses(fechaLocal.MES))


        setFiltroFecha({ ...filtroFecha })

        return { FECHA_PARTIDA: FECHA_INICIAL, ACCION_DESDE: filtroFecha.ACCION_DESDE, ACCION_HASTA: filtroFecha.ACCION_HASTA, MES: parseInt(fechaLocal.MES), ANYO: fechaLocal.ANIO }
    }


    const descargarFichero = (ID) => {
        window.open(`${ObtenerEndPoint()}api/NextGroup/DescargaCarpetaDocDocumento/${ID}/${window.btoa(obtenerToken())}`, '_blank').focus();
    }




    const paginarTabla = (page, pageSize) => {
        if (noticias.length > 0) {
            let pInicio = (pageSize * page) - (datosPaginacion.numPagina);
            let pFinal = pageSize * page;
            setDatosPaginacion(
                {
                    iniPage: page,
                    inicio: pInicio,
                    final: pFinal,
                    numPagina: datosPaginacion.numPagina
                }
            )
        }
    }

    const updateNumberPage = (current, size) => {
        setDatosPaginacion(
            {
                iniPage: 1,
                inicio: 1,
                final: size,
                numPagina: size
            }
        )
    }


    const filtrarNoticiasPorFecha = (REGISTROS) => {
        const { ACCION_DESDE, ACCION_HASTA, FECHA_PARTIDA } = REGISTROS


        GetNoticias(filtroLocal.ORDERCOLUM, filtroLocal.ORDERDIR, filtroLocal.ID, FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, filtroLocal.PALABRA)

    }


    const filtrarNoticiasLocal = (REGISTROS, FILTRO_LOCAL) => {
        const { ID, NOMBRE } = seleccionadoActual(filtroLocal.CATEGORIAS)
        const { ID_CATEGORIA, ID_ESTADO,ID_TIPO_NOTICIA } = FILTRO_LOCAL


        let FILTRAR_NOTICIAS = REGISTROS

        if (ID_ESTADO !== undefined && ID_ESTADO !== null) {
            FILTRAR_NOTICIAS = FILTRAR_NOTICIAS.filter((item) => item.ID_ESTADO_NOTICIA === ID_ESTADO)
        }

        if (ID_CATEGORIA !== undefined && ID_CATEGORIA !== null && ID_CATEGORIA !== -1) {
            let NEW_CATEGORIA = ID_CATEGORIA.toString()
            FILTRAR_NOTICIAS = FILTRAR_NOTICIAS.filter((item) => item.IDS_CATEGORIAS.includes(NEW_CATEGORIA))
        }


        if (ID_TIPO_NOTICIA !== undefined && ID_TIPO_NOTICIA !== null && ID_TIPO_NOTICIA !== -1) {
            FILTRAR_NOTICIAS = FILTRAR_NOTICIAS.filter((item) => item.ID_NOTICIA_TIPO === ID_TIPO_NOTICIA)
        }



        if(FILTRAR_NOTICIAS !== undefined && FILTRAR_NOTICIAS !== null && FILTRAR_NOTICIAS.length > 0){
            FILTRAR_NOTICIAS = FILTRAR_NOTICIAS.filter((item) => item.ID_ESTADO_NOTICIA === 2)
        }





        return FILTRAR_NOTICIAS;
    }





    const GetCategoriaNoticia = async (ORDERCOLUM, ORDERDIR, ID, NOMBRE, DESCRIPCION, DESTACADA, CATEGORIAS) => {
        let licencia = await GetCategoriaNoticiaEnAPI(ORDERCOLUM, ORDERDIR, ID, NOMBRE, DESCRIPCION, DESTACADA)
        if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {

            let CATEGORIAS = []
            CATEGORIAS.push({ ID: -1, NOMBRE: traducirPagina("Todas").toUpperCase(), DESCRIPCION: traducirPagina("Todas").toUpperCase(), SELECCIONADO: false })

            licencia.REGISTROS.map((registro, i) => {
                registro.SELECCIONADO = false
                CATEGORIAS.push({ ID: registro.ID, NOMBRE: registro.NOMBRE, DESCRIPCION: registro.DESCRIPCION, SELECCIONADO: false })
            })


            filtroLocal.CATEGORIAS = CATEGORIAS


            setFiltroLocal({ ...filtroLocal })
        } else {
            //setNoticias(null)

        }
        return licencia
    }



    const seleccionarRegistro = (arrayOriginal, param, ID) => {
        let expresion = `arrayOriginal.${param}`
        let convertir = eval(expresion)

        convertir.map((registro) => {
            registro.SELECCIONADO = registro.ID === ID ? true : false
        })

        setFiltroLocal({ ...arrayOriginal })
    }

    const seleccionadoActual = (registros) => {
        let REGISTRO = registros.find((registro) => registro.SELECCIONADO)
        return REGISTRO === undefined ? { ID: null, DESCRIPCION: null } : REGISTRO
    }

    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })



    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let { ACCION_DESDE, ACCION_HASTA, FECHA_PARTIDA, ANYO } = fechaInicial();

            filtroLocal.ANYOS = crearAnyos(ANYO, 6)
            setFiltroLocal({ ...filtroLocal })


            /*
            let listaAnios = [];
    
            for (var i = 2018; i <= ANYO; i++) {
                listaAnios.push(i)
            }
            setAnios(listaAnios)
    
            filtroFecha.MES_SELECCIONADO = CodigoAMeses(MES)
            setFiltroFecha({ ...filtroFecha })
    */
            filtroFecha.ACCION_DESDE = ACCION_DESDE;
            filtroFecha.ACCION_HASTA = ACCION_HASTA;
            filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA

            setFiltroFecha({ ...filtroFecha })
            GetCategoriaNoticia(1, "A", "", "", null);

            GetNoticias(filtroLocal.ORDERCOLUM, filtroLocal.ORDERDIR, filtroLocal.ID, filtroFecha.FECHA_PARTIDA, filtroFecha.ACCION_DESDE, filtroFecha.ACCION_HASTA, filtroLocal.PALABRA)
        }

    }, [])





    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {traducirPagina("NOTICIAS_GRUPO").toUpperCase()}
        </>,
        document.getElementById("tituloMenu")
    );



    return (
        <>
            <div style={{ padding: '20px' }} ref={ref}>
                <div className='mantenimiento_item1' style={{ gap: '10px 0px', paddingBottom: '10px', justifyContent: 'space-between' }}>
                    <>
                        <ul className="nested-dropdowns mantenimiento_item1" style={{ gap: '10px 0px' }}>
                            <li

                                onClick={() => {
                                    let { FECHA_PARTIDA } = fechaInicial();
                                    filtroFecha.CAMBIO_DIA = true;
                                    filtroFecha.CAMBIO_MES = false;
                                    filtroFecha.CAMBIO_ANIO = false;
                                    filtroFecha.ACCION_DESDE = 4;
                                    filtroFecha.ACCION_HASTA = 5;
                                    filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA

                                    setFiltroFecha({ ...filtroFecha })

                                    filtrarNoticiasPorFecha(filtroFecha)
                                }}
                                style={filtroFecha.CAMBIO_DIA ? { backgroundColor: 'var(--amarillo-serca)', color: 'var(--azul-claro-serca)' } : {}}

                            >
                                <div className={`nested-dropdowns__item icono_grande`}>
                                    {traducirPagina("Hoy").toUpperCase()}
                                </div>
                            </li>


                            <li className={filtroLocal.ACTIVE_MENU === 1 && "nested-dropdowns_active"}
                                onClick={() => {
                                    filtroLocal.ACTIVE_MENU = filtroLocal.ACTIVE_MENU === 1 ? 0 : 1; setFiltroLocal({ ...filtroLocal })
                                }}
                                style={filtroFecha.CAMBIO_MES ? { backgroundColor: 'var(--amarillo-serca)', color: 'var(--azul-claro-serca)' } : {}}

                            >
                                <div className={`nested-dropdowns__item`}  >
                                    {traducirPagina(seleccionadoActual(filtroLocal.INICIAL_MES).DESCRIPCION).toUpperCase()}


                                    {filtroLocal.ACTIVE_MENU === 1 ?
                                        <UpOutlined></UpOutlined>
                                        :
                                        <DownOutlined></DownOutlined>

                                    }
                                </div>

                                <ul className={filtroLocal.ACTIVE_MENU === 1 && "open_dropdowns"} style={{ width: 'auto' }}>
                                    {filtroLocal.INICIAL_MES.map((registro, i) =>
                                        <li key={registro.ID} onClick={() => {
                                            seleccionarRegistro(filtroLocal, "INICIAL_MES", registro.ID)
                                            filtroFecha.ANYO_SELECCIONADO = seleccionadoActual(filtroLocal.ANYOS).DESCRIPCION


                                            let MES_LOCAL = CodigoAMeses(registro.ID)
                                            const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(MES_LOCAL), filtroFecha.ANYO_SELECCIONADO, { DESDE: 0, HASTA: 1 });

                                            filtroFecha.CAMBIO_DIA = false;
                                            filtroFecha.CAMBIO_MES = true;
                                            filtroFecha.CAMBIO_ANIO = true;
                                            filtroFecha.ACCION_DESDE = 0;
                                            filtroFecha.ACCION_HASTA = 1;
                                            filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                                            filtroFecha.MES_SELECCIONADO = MES_LOCAL
                                            filtroFecha.CODIGO_MES = registro.ID

                                            filtrarNoticiasPorFecha(filtroFecha)

                                            setFiltroFecha({ ...filtroFecha })


                                        }}>{traducirPagina(registro.DESCRIPCION).toUpperCase()}</li>
                                    )}
                                </ul>

                            </li>

                            <li className={filtroLocal.ACTIVE_MENU === 2 && "nested-dropdowns_active"}
                                onClick={() => { filtroLocal.ACTIVE_MENU = filtroLocal.ACTIVE_MENU === 2 ? 0 : 2; setFiltroLocal({ ...filtroLocal }) }}
                                style={filtroFecha.CAMBIO_ANIO ? { backgroundColor: 'var(--amarillo-serca)', color: 'var(--azul-claro-serca)' } : {}}

                            >
                                <div className={`nested-dropdowns__item`} >

                                    {seleccionadoActual(filtroLocal.ANYOS).DESCRIPCION}


                                    {filtroLocal.ACTIVE_MENU === 2 ?
                                        <UpOutlined></UpOutlined>
                                        :
                                        <DownOutlined></DownOutlined>

                                    }
                                </div>

                                <ul className={filtroLocal.ACTIVE_MENU === 2 && "open_dropdowns"}>
                                    {filtroLocal.ANYOS.map((registro, i) =>
                                        <li key={i} onClick={() => {
                                            seleccionarRegistro(filtroLocal, "ANYOS", registro.ID)

                                            const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), registro.DESCRIPCION, { DESDE: 2, HASTA: 3 });


                                            filtroFecha.CAMBIO_DIA = false;
                                            filtroFecha.CAMBIO_MES = false;
                                            filtroFecha.CAMBIO_ANIO = true;
                                            filtroFecha.ACCION_DESDE = 2;
                                            filtroFecha.ACCION_HASTA = 3;
                                            filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA;
                                            filtroFecha.ANYO_SELECCIONADO = registro.DESCRIPCION;

                                            setFiltroFecha({ ...filtroFecha })
                                            filtrarNoticiasPorFecha(filtroFecha)


                                        }}>{registro.DESCRIPCION}</li>
                                    )}
                                </ul>
                            </li>


                            <li className={filtroLocal.ACTIVE_MENU === 3 && "nested-dropdowns_active"}
                                onClick={() => { filtroLocal.ACTIVE_MENU = filtroLocal.ACTIVE_MENU === 3 ? 0 : 3; setFiltroLocal({ ...filtroLocal }) }}
                                style={{width:'270px'}}
                            >
                                <div className={`nested-dropdowns__item`} >

                                    {seleccionadoActual(filtroLocal.CATEGORIAS).ID === null || seleccionadoActual(filtroLocal.CATEGORIAS).ID === -1 ? traducirPagina("Seleccione_categoria") : seleccionadoActual(filtroLocal.CATEGORIAS).NOMBRE}


                                    {filtroLocal.ACTIVE_MENU === 3 ?
                                        <UpOutlined></UpOutlined>
                                        :
                                        <DownOutlined></DownOutlined>

                                    }
                                </div>

                                <ul className={filtroLocal.ACTIVE_MENU === 3 && "open_dropdowns"}>
                                    {filtroLocal.CATEGORIAS.map((registro, i) =>
                                        <li key={i} onClick={() => {
                                            seleccionarRegistro(filtroLocal, "CATEGORIAS", registro.ID)

                                            let SELECCIONADO = registro.ID
                                            filtroLocal.ID_CATEGORIA = SELECCIONADO
                                            setFiltroLocal({ ...filtroLocal })

                                        }}>{registro.NOMBRE}</li>
                                    )}
                                </ul>
                            </li>

                            {filtroLocal.TIPOS_NOTICIA !== null && filtroLocal.TIPOS_NOTICIA.length > 0 ?
                                filtroLocal.TIPOS_NOTICIA.map((registro) =>
                                    <li
                                        onClick={() => {
                                            seleccionarRegistro(filtroLocal, "TIPOS_NOTICIA", registro.ID)
                                            
                                            filtroLocal.ID_TIPO_NOTICIA = registro.ID === 0 ? -1 :registro.ID
                                            setFiltroLocal({...filtroLocal})


                                        }}
                                        style={registro.SELECCIONADO ? { backgroundColor: 'var(--amarillo-serca)', color: 'var(--azul-claro-serca)' } : {}}
                                    >
                                        <div className={`nested-dropdowns__item icono_grande`}>
                                            {registro.DESCRIPCION}
                                        </div>
                                    </li>

                                )
                                :
                                null
                            }

                        </ul>


                        <div className="grid-container" style={{ backgroundColor: '#eee', padding: '0px', height: '45px' }}>
                            <div className="grid-item">
                                <input className="form-control eliminarFoco " type="text" aria-label="Search" placeholder={traducirPagina("BuscadorPalabra")} style={{ backgroundColor: "transparent", border: '0px', height: '100%', color: '#000', width: '250px' }} autoComplete="off"
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            GetNoticias(filtroLocal.ORDERCOLUM, filtroLocal.ORDERDIR, filtroLocal.ID, filtroFecha.FECHA_PARTIDA, filtroFecha.ACCION_DESDE, filtroFecha.ACCION_HASTA, filtroLocal.PALABRA)

                                        }
                                    }}
                                    onChange={(e) => {

                                        filtroLocal.PALABRA = e.target.value;

                                        setFiltroLocal({ ...filtroLocal })

                                    }}
                                    value={filtroLocal.PALABRA} />
                            </div>

                            <div className="grid-item" onClick={(e) => {

                            }}>
                                <button style={{ visibility: filtroLocal.PALABRA.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2 btnEliminarBuscador" onClick={(e) => {
                                    filtroLocal.PALABRA = ""; setFiltroLocal({ ...filtroLocal })
                                    GetNoticias(filtroLocal.ORDERCOLUM, filtroLocal.ORDERDIR, filtroLocal.ID, filtroFecha.FECHA_PARTIDA, filtroFecha.ACCION_DESDE, filtroFecha.ACCION_HASTA, filtroLocal.PALABRA)

                                    /*setLicencias(filtroLocalDeLaTabla("", licenciasAux));*/
                                }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                            </div>


                            <div className="grid-item" onClick={(e) => {
                                GetNoticias(filtroLocal.ORDERCOLUM, filtroLocal.ORDERDIR, filtroLocal.ID, filtroFecha.FECHA_PARTIDA, filtroFecha.ACCION_DESDE, filtroFecha.ACCION_HASTA, filtroLocal.PALABRA)

                            }}>
                                <button className="btn_buscador_tarifa">  <SearchOutlined style={{ fontSize: '20px' }} /> {traducirPagina("Buscar")} </button>
                            </div>
                        </div>

                    </>

                </div>
            </div>


            <div className="layaut_noticia">
                <div className="layout_item1" style={{ height: `calc(100vh - ${(140 + alturaSubmenu)}px )` }}>
                    {noticias === null ?
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh' }}> <h4>{traducirPagina("Sin_resultados")}</h4> </div>
                        :
                        <div className="container_noticia" style={{ height: `calc(100vh - ${(192 + alturaSubmenu)}px )` }}>
                            {
                                noticias.length > 0 ?
                                    filtrarNoticiasLocal(noticias, filtroLocal).map((registro, i) =>
                                        (i + 1) >= datosPaginacion.inicio && (i + 1) <= datosPaginacion.final ?

                                            <div className="item_noticia">
                                                <div className="card__cover">
                                                    <div className="card_noticia_imagen">
                                                        <img
                                                            onLoad={(e) => {
                                                                if (e.target.clientHeight > e.target.clientWidth || e.target.clientHeight === e.target.clientWidth) {
                                                                    //imagenes verticales
                                                                    e.target.style.height = "170px"
                                                                    e.target.style.width = "100%"

                                                                } else {
                                                                    //imagenes horinzontales
                                                                    e.target.style.height = "100%"
                                                                    e.target.style.width = "200px"
                                                                }


                                                            }}
                                                            onError={(e) => { e.target.src = "./imagenes/sinimagen.jpg"; }}
                                                            src={`${ObtenerEndPoint()}api/NextGroup/GetImagenNoticia/${registro.ID}/${window.btoa(obtenerToken())}`}
                                                        >

                                                        </img>

                                                    </div>
                                                </div>

                                                <div className="card__content">
                                                    <div className="header_noticia" onClick={() => {
                                                        setNoticiaSeleccionada(registro)
                                                        setAbrirDetalleNoticia(true)
                                                    }}>

                                                        <span style={{ height: '60px' }}>{registro.TITULO}</span>
                                                        <span style={{ fontSize: '13px' }}>
                                                            <span className="text_primary_noticia" style={{ fontSize: '15px' }}> {traducirPagina("Fecha")}:</span>
                                                            {registro.FECHA}

                                                            <span className="text_primary_noticia" style={{ fontSize: '15px' }}> {traducirPagina("Publicada_el")}:</span>
                                                            {registro.FECHA_PUBLICACION}
                                                        </span>
                                                    </div>

                                                    <div className="body_noticia">
                                                        <div className="texto_noticia" style={{ height: '50px', fontSize: '16px' }}>
                                                            {recortarCadena(registro.TEXTO_LIMPIO, 300, " ...")}
                                                        </div>
                                                    </div>

                                                    <div className="foter_noticia">

                                                        <ul>
                                                            <li className="estiloCategorias">
                                                                {registro.TIPO_NOTICIA}
                                                            </li>
                                                        </ul>

                                                        <div className="contianer_foter_noticia">
                                                            <div>
                                                                <HeartOutlined></HeartOutlined>
                                                            </div>

                                                            <div>
                                                                <ShareAltOutlined></ShareAltOutlined>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            :
                                            null

                                    )
                                    :
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                            }
                        </div>



                    }


                    <div className="menu_mantenimiento" style={{ paddingBottom: '0px', justifyContent: 'center' }}>



                        {noticias !== null ?
                            noticias.length > 0 ?
                                <Pagination
                                    showSizeChanger
                                    current={datosPaginacion.iniPage}
                                    onShowSizeChange={(current, size) => { updateNumberPage(current, size) }}
                                    total={filtrarNoticiasLocal(noticias, filtroLocal).length}
                                    showTotal={() => ` ${filtrarNoticiasLocal(noticias, filtroLocal).length} ${traducirPagina("Noticias")}`}
                                    defaultPageSize={40}
                                    onChange={(page, pageSize) => { paginarTabla(page, pageSize) }}
                                > </Pagination>
                                :
                                null
                            : null
                        }

                    </div>
                </div>

            </div>


            {abrirVisor ?
                <VisorGenerico
                    title={""}
                    ABRIR_VISOR={abrirVisor}
                    CERRAR_VISOR={setAbrirVisor}

                    PROPIEDADES_DOC={ficheroSeleccionado}
                    MOSTRAR_BOTON_DESCARGA={true}
                    EVENTO_DESCARGA={descargarFichero}
                >
                </VisorGenerico>
                :
                null
            }


            {
                abrirDetalleNoticia ?
                    <FichaDetalleNoticia
                        title={traducirPagina("FICHA_NOTICIA")}
                        ABRIR_FICHA={abrirDetalleNoticia}
                        CERRAR_FICHA={setAbrirDetalleNoticia}
                        REGISTRO_SELECCIONADO={noticiaSeleccionada}
                    >
                    </FichaDetalleNoticia>
                    :
                    null
            }





            {modalBajaVisible.ABRIR_MODAL ?
                <Modal
                    visible={modalBajaVisible.ABRIR_MODAL}
                    width={600}
                    centered
                    title={traducirPagina("Dar_baja")}
                    afterClose={() => {
                        modalBajaVisible.ABRIR_MODAL = false
                        modalBajaVisible.ID = 0
                        modalBajaVisible.ID_PADRE = 0
                        modalBajaVisible.NOMBRE = ""
                        modalBajaVisible.ES_DOCUMENTO = false
                        setModalBajaVisible({ ...modalBajaVisible })
                    }}
                    onCancel={() => { modalBajaVisible.ABRIR_MODAL = false; setModalBajaVisible({ ...modalBajaVisible }) }}
                    style={{ zIndex: '99999999' }}
                    footer={[
                        <Button key="back" onClick={() => { modalBajaVisible.ABRIR_MODAL = false; setModalBajaVisible({ ...modalBajaVisible }) }}>
                            NO
                        </Button>,
                        <Button style={{ backgroundColor: '#000' }} key="submit" type="primary" onClick={() => {

                            //DarDeBajaCarpeta(modalBajaVisible.ID, modalBajaVisible.ID_PADRE, modalBajaVisible.ES_DOCUMENTO);


                            modalBajaVisible.ABRIR_MODAL = false;
                            setModalBajaVisible({ ...modalBajaVisible })

                        }}> SI</Button>
                    ]}
                >
                    <Row>
                        <Col md={24} className="mt-2 mb-2">
                            {modalBajaVisible.ES_DOCUMENTO ?
                                <span className="tituloRecuperarEmail">{`¿Esta seguro de querer eliminar este documento?`} </span>

                                :
                                <span className="tituloRecuperarEmail">{`¿Esta seguro de querer eliminar la carpeta y todo su contenido?`} </span>

                            }
                        </Col>

                    </Row>
                </Modal>
                : null

            }
        </>
    );
}



Noticias.propTypes = {
    EVENTO_MENU: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        search: state.searchValue,
        configApp: state.configApp,
        usuario: state.usuario,
        clienteSeleccionado: state.clienteSeleccionado,
        activeItemReferencia: state.activeItemReferencia,

    };
}

export default connect(mapStateToProps)(Noticias);